import React, { lazy } from 'react';
import { Switch, Route } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';

const Jobs = lazy(() => import('../../container/Jobs&Project/JobsList'));
const CreateProject = lazy(() => import('../../container/Jobs&Project/create-project'));
const CreateInternalUser = lazy(() => import('../../container/admin/internal-users/CreateUsers'));
const InternalUsers = lazy(() => import('../../container/admin/internal-users/InternalUsers'));

const CustomerUser = lazy(() => import('../../container/admin/customer-user/Users'));
const CreateCustomerUser = lazy(() => import('../../container/admin/customer-user/CreateUsers'));
const CustomerAccount = lazy(() => import('../../container/admin/customer-account/Accounts'));
const CreateCustomerAccount = lazy(() => import('../../container/admin/customer-account/CreateAccounts'));
const AllDetails = lazy(() => import('../../container/AllDetail'));
const Editor = lazy(() => import('../../container/admin/text-editor/TextEditor'));
const ProfilePage = lazy(() => import('../../container/admin/ProfilePage'));
const ProfilePage2 = lazy(() => import('../../container/admin/profileInternalUser'));
const Orgreport = lazy(() => import('../../container/Reports/Myreport'));

function DashboardRoutes() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={path} component={Jobs} />
      <Route path={`${path}/create-project`} component={CreateProject} />
      <Route path={`${path}/internal-users`} component={InternalUsers} />
      <Route path={`${path}/create-internal-users`} component={CreateInternalUser} />
      <Route path={`${path}/account`} component={CustomerAccount} />
      <Route path={`${path}/create-account`} component={CreateCustomerAccount} />
      <Route path={`${path}/users`} component={CustomerUser} />
      <Route path={`${path}/create-user/`} component={CreateCustomerUser} />
      <Route path={`${path}/allDetails`} component={AllDetails} />
      <Route path={`${path}/editor`} component={Editor} />
      <Route path={`${path}/profilepage`} component={ProfilePage} />
      <Route path={`${path}/Profile-Page`} component={ProfilePage2} />
      <Route path={`${path}/reports`} component={Orgreport} />
    </Switch>
  );
}

export default DashboardRoutes;
